/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_MoreInputs */



/**
* | output |
* | --- |
* | "More" |
*
* @param {Layout_Header_MoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_more = /** @type {((inputs?: Layout_Header_MoreInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_MoreInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehr")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("更多")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("更多")
	if (locale === "ko") return /** @type {LocalizedString} */ ("더 보기")
	return /** @type {LocalizedString} */ ("More")
});